import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { usePopperTriggerProps } from '@sgui-plus/components/popper'
import type { ExtractPropTypes } from 'vue'

export type TooltipTriggerType = 'hover' | 'focus' | 'click' | 'contextmenu'

export const useTooltipTriggerProps = buildProps({
  ...usePopperTriggerProps,
  disabled: Boolean,
  trigger: {
    type: definePropType<TooltipTriggerType | TooltipTriggerType[]>([String, Array]),
    default: 'hover'
  }
} as  const)

export type SgTooltipTriggerProps = ExtractPropTypes<
  typeof useTooltipTriggerProps
>
